import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.css']
})
export class ProfilePictureComponent implements OnInit {
  @Input() name: string;
  letter: string;
  oldName: string;
  static colors = [
    '#A9F1E1',
    '#A6E6F1',
    '#E9E073',
    '#FAD393',
    '#A9F1C9',
    '#B7CCF3',
    '#DDF18E',
    '#F8C0B6',
  ]
  color: string;

  constructor() { }

  ngOnInit() {
    this.update();
  }

  update() {
    this.oldName = this.name;
    this.getLetter();
    this.getColor();
  }

  ngDoCheck() {
    if (this.oldName != this.name) {
      this.update();
    }
  }

  getLetter(): void {
    this.letter = this.name.trim().slice(0, 1);
  }

  getColor(): void {
    var hash = this.hashCode(this.name);
    this.color = ProfilePictureComponent.colors[Math.abs(hash) % ProfilePictureComponent.colors.length];
  }

  hashCode(s): number {
    var hash = 0, i, chr;
    if (s.length === 0) return hash;
    for (i = 0; i < s.length; i++) {
      chr = s.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  };
}
